import { render } from "./Toast.vue?vue&type=template&id=36fa7d8d&ts=true"
import script from "./Toast.vue?vue&type=script&lang=ts"
export * from "./Toast.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__